import api from './axios';

export const adminBrightPatternTemplateApi = {
  list: (params = {}) => api.get('/admin/bright-pattern-templates', { params }).then((r) => r.data),
  getById: (id) => api.get(`/admin/bright-pattern-templates/${id}`).then((r) => r.data),
  create: (data) => api.post('/admin/bright-pattern-templates', data).then((r) => r.data),
  update: (id, data) => api.patch(`/admin/bright-pattern-templates/${id}`, data).then((r) => r.data),
  deactivate: (id) => api.delete(`/admin/bright-pattern-templates/${id}`).then((r) => r.data),
};
